import { TipoServicioLabel, ViajeTrasladoTipoServicio } from 'app/viaje/models';

/**
 * Helpers reutilizables para formatear y mostrar valores de filtros
 */

/**
 * Obtiene el label amigable de un tipo de servicio
 * @param serviceType - Código del tipo de servicio
 * @returns Label amigable del tipo de servicio o el código si no se encuentra
 */
export const getServiceTypeLabel = (serviceType: ViajeTrasladoTipoServicio | 'Todos'): string => {
  if (serviceType === 'Todos') {
    return 'Todos';
  }
  return TipoServicioLabel[serviceType] || serviceType;
};

/**
 * Obtiene el label amigable del tipo de cliente
 * @param clientType - Tipo de cliente
 * @returns Label amigable
 */
export const getClientTypeLabel = (clientType: 'BusinessClient' | 'ParticularClient' | 'ParticularApp' | 'AllClient'): string => {
  const labels = {
    BusinessClient: 'Empresa',
    ParticularClient: 'Particular',
    ParticularApp: 'Particular App',
    AllClient: 'Todos'
  };
  return labels[clientType] || clientType;
};

/**
 * Formatea un valor booleano para mostrar Sí/No
 * @param value - Valor booleano
 * @returns "Sí" o "No"
 */
export const formatBooleanLabel = (value: boolean): string => {
  return value ? 'Sí' : 'No';
};

/**
 * Formatea una cantidad de elementos seleccionados
 * @param count - Cantidad de elementos
 * @param singular - Texto singular (ej: "seleccionado")
 * @param plural - Texto plural (ej: "seleccionados")
 * @returns Texto formateado
 */
export const formatCountLabel = (count: number, singular: string = 'seleccionado', plural: string = 'seleccionados'): string => {
  return `${count} ${count === 1 ? singular : plural}`;
};

